import React from 'react';

const SocialLinks = ({ className = '' }) => (
    <nav className={`social-links ${className}`.trim()} aria-label="Follow Lick Before You Stick">
        <a
            className="social-link"
            href="https://x.com/lickbefore"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow @lickbefore on X"
            title="@lickbefore on X"
        >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.9 2H22l-6.77 7.74L23.2 22h-6.24l-4.89-6.39L6.48 22H3.36l7.26-8.3L2.98 2h6.4l4.42 5.84L18.9 2zm-1.09 17.84h1.72L8.44 4.05H6.59l11.22 15.79z"/>
            </svg>
        </a>
        <a
            className="social-link"
            href="https://www.instagram.com/lickbefore/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow @lickbefore on Instagram"
            title="@lickbefore on Instagram"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8"/>
                <circle cx="17.4" cy="6.7" r="1.1" fill="currentColor"/>
            </svg>
        </a>
    </nav>
);

export default SocialLinks;
